import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["onAnimationiteration"]

import {computed, reactive} from "vue";

interface ListProps<T = unknown> {
  list: T[],
  direction: 'left' | 'top',
  sectionLength: number,
  interval: string,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ScrollList',
  props: {
    list: {},
    direction: {},
    sectionLength: {},
    interval: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v49af218a": (props.interval)
}))

const props = __props;
const info = reactive({idx: 0})
const originList = computed(() => repeatArray(props.list, props.sectionLength))
const subList = computed(() => {
  if (props.list.length == 0) return []
  return [...originList.value, ...originList.value].slice(info.idx, info.idx + props.sectionLength * 2)
})

function repeatArray<T>(arr: T[], targetLength: number): T[] {
  if (arr.length === 0) return [];

  const result: T[] = [...arr];

  while (result.length < targetLength) {
    // 每次添加整个数组，但不超过目标长度
    const remaining = targetLength - result.length;
    result.push(...arr.slice(0, remaining));
  }

  return result;
}

const onAnimationIteration = () => info.idx = (info.idx + props.sectionLength) % originList.value.length


return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subList.value, (item, k) => {
    return (_openBlock(), _createElementBlock("view", {
      class: _normalizeClass(["item", __props.direction]),
      key: k,
      onAnimationiteration: ($event: any) => (k === 0 && onAnimationIteration())
    }, [
      _renderSlot(_ctx.$slots, "item", { item: item })
    ], 42, _hoisted_1))
  }), 128))
}
}

})